export {
  emailValidationRFC2822,
  passwordValidation,
  phoneValidation,
  referralValidation,
} from "./validation";
